import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiJson, assetUrl } from "../../utils/api";
import { Disclaimer } from "./MarriageLayout";
import useSeo from "../../hooks/useSeo";

export default function MarriageCertificate() {
  const { code } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const shareUrl = `${window.location.origin}/marriage/certificate/${code}`;

  useSeo({
    title: "模拟结婚纪念证",
    metaDescription: "电子纪念证，仅供娱乐，不具法律效力。",
    path: `/marriage/certificate/${code || ""}`,
  });

  useEffect(() => {
    apiJson(`/api/marriage/certificate/${code}`)
      .then(({ res, data: d }) => {
        if (!res.ok) throw new Error(d?.detail || "还没有纪念证");
        setData(d);
      })
      .catch((err) => setError(err.message));
  }, [code]);

  const share = async () => {
    const text = `我们完成了模拟领证（仅纪念，无法律效力） ${shareUrl}`;
    if (navigator.share) {
      await navigator.share({ title: "模拟结婚纪念证", text, url: shareUrl });
      return;
    }
    await navigator.clipboard.writeText(shareUrl);
    alert("链接已复制，可发到微信");
  };

  if (error) return <p className="text-red-500">{error}</p>;
  if (!data) return <p className="text-gray-400">生成中...</p>;

  const sim = data.simulation || {};

  return (
    <div className="max-w-xl mx-auto space-y-4">
      <Disclaimer />
      <div className="bg-gradient-to-b from-red-700 to-red-900 text-amber-50 rounded-3xl p-8 shadow-xl text-center space-y-4">
        <p className="tracking-[0.4em] text-amber-200">模拟结婚纪念证</p>
        <h1 className="text-2xl font-bold">
          {data.male_name}　♥　{data.female_name}
        </h1>
        <p className="text-sm text-amber-100">{sim.declaration}</p>
        <p>模拟登记日期：{(sim.registered_at || "").slice(0, 10)}</p>
        <p className="font-mono">专属编号 {sim.certificate_no}</p>
        <div className="flex justify-center gap-6 py-4">
          {[data.male_avatar, data.female_avatar].map((src, idx) =>
            src ? (
              <img key={idx} src={assetUrl(src)} alt="头像" className="w-20 h-20 rounded-full object-cover border-2 border-amber-200" />
            ) : (
              <div key={idx} className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center text-2xl">
                {(idx === 0 ? data.male_name : data.female_name)?.[0] || "·"}
              </div>
            )
          )}
        </div>
        {data.couple_photo ? (
          <img src={assetUrl(data.couple_photo)} alt="合影" className="w-full max-h-48 object-cover rounded-2xl" />
        ) : null}
        <img
          alt="纪念页二维码"
          className="mx-auto bg-white p-2 rounded-xl"
          src={`https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent(shareUrl)}`}
        />
        <p className="text-[10px] text-amber-200">扫码进入情侣专属纪念页 · 无法律效力</p>
      </div>
      <div className="flex gap-3 justify-center">
        <button onClick={share} className="px-5 py-2 rounded-full bg-rose-500 text-white">
          分享给微信好友/朋友圈
        </button>
        <button onClick={() => window.print()} className="px-5 py-2 rounded-full border">
          打印纪念证
        </button>
      </div>
    </div>
  );
}
